export const LINKS = {
  spotify: "https://open.spotify.com/album/2Gvj0lWJBiXVXoM3lVKTMP",
  spotifyEmbed:
    "https://open.spotify.com/embed/album/2Gvj0lWJBiXVXoM3lVKTMP?utm_source=generator&theme=0",
  appleMusic: "https://music.apple.com/it/album/linea-cremisi-ep-ep/6820101087",
  youtubeMusic: "https://music.youtube.com/channel/UCzu5aFvL2riRLxikjn_CUHA",
  youtube: "https://www.youtube.com/@LineaCremisiOfficial",
  instagram: "https://www.instagram.com/lineacremisi",
};

export const BOOKING_EMAIL = "booking@lineacremisi.com";

export const BOOKING_MAILTO = `mailto:${BOOKING_EMAIL}?subject=${encodeURIComponent(
  "Richiesta live — Linea Cremisi"
)}&body=${encodeURIComponent(
  "Ciao Linea Cremisi,\n\nvorremmo prenotare un vostro live.\n\nLocale / evento:\nCittà:\nData indicativa:\nContatto:\n"
)}`;



export const RECORDING = {
  period: "4 maggio — 8 luglio 2026",
  studio: "GGF Legacy Studio",
  studioCity: "Frattamaggiore (NA)",
  mixStudio: "The Vessel Recording Studio",
  mixCity: "San Nicola La Strada (CE)",
  engineer: "Massimiliano Pone",
  label: "GGF Studio",
};

export const ENDORSEMENT = {
  member: "Cristiano Nappa",
  brand: "Parşömen Cymbals",
  series: "Inferno",
  url: "https://parsomencymbals-store.myshopify.com/pages/endorser/cristiano-nappa",
  photo: "/photos/cymbal_cristiano.jpg",
};


export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_5f694186-6475-4087-b67f-8778ce43c648/artifacts/e7f134b3f02ffb91_LineaCremisiLogo.jpg";

export const ALBUM_COVER =
  "https://i.scdn.co/image/ab67616d0000b27346312ef7202de80857e7d088";

export const IMAGES = {
  concert: "/photos/stage_band_v2.jpg",
  stage: "/photos/stage_duo.jpg",
  vocalist: "/photos/p3.jpg",
  guitarist: "/photos/p4.jpg",
  bassist: "/photos/p2.jpg",
  drummer: "/photos/p5.jpg",
  group: "/photos/group.jpg",
};

export const TRACKS = [
  {
    title: "Lentamente",
    spotify: "https://open.spotify.com/track/0zCquPFTE7vNACv7HrnY9F",
    duration: "2:18",
    preview:
      "https://p.scdn.co/mp3-preview/7b4668188d4e532a33dd68c3948cb135e6fd8394",
    lyrics: `Due dita d'oro in un bicchiere
Ci nuota dentro una vita
Una canzone ha il suo sapore
Il basso conta i battiti del cuore

Lentamente
Lentamente
Lentamente
Lentamente

Legno vecchio sopra ad un bancone
Un cameriere serve un disertore
La pace è solo quieto dolore
Meglio morire adesso per amore

Lentamente
Lentamente
Lentamente
Lentamente
Lentamente`,
  },
  {
    title: "Sotto Un Cielo Rosso Cremisi",
    spotify: "https://open.spotify.com/track/651HGpIgvOfRdUTpf2Qjci",
    duration: "4:52",
    preview:
      "https://p.scdn.co/mp3-preview/de25037aa8a7b70f84d0ca11ed5a45295bece499",
    lyrics: `C'è una goccia fredda che ti scende
Lentamente giù lungo il collo
Ma hai una vita tranquilla e felice
Hai fatto tutto il tuo dovere
Ma quella goccia è lì che ti scende
Che ti ricorda che non hai risposte

Un uomo, un Dio, una vita
Ci devi credere, tu devi credere
Tu sei lì, tu sei lì, lì sotto un cielo rosso cremisi

C'è un ragazzino fuori da una scuola, scende il piede di un uomo sulla strada,
ma lui non vede questo, lui non vede questo cielo

C'è un calore su che ti sale
Il sangue torna a circolare
Stai cercando di alzare lo sguardo
Di afferrare quel tenue bagliore
Ricordi quando eri un ragazzo
E rubavi i sogni ad un pazzo

Un uomo, un Dio, una vita
Ci devi credere, tu devi credere
Tu sei lì, tu sei lì, lì sotto un cielo rosso cremisi

C'è un ragazzino fuori da una scuola, scende il piede di un uomo sulla strada,
ma lui non vede questo, lui non vede questo cielo

Io vivo, io respiro, io piango, io muoio, io amo lì sotto un cielo rosso cremisi
Io vivo, io respiro, io piango, io muoio, io amo lì sotto un cielo rosso cremisi`,
  },
  {
    title: "Amore Abbracciami",
    spotify: "https://open.spotify.com/track/0D2OsaPMlncEaSRM5T4B9G",
    duration: "4:18",
    preview:
      "https://p.scdn.co/mp3-preview/67688d603510c4fffad8c3b75ec27fb1c2aea003",
    lyrics: `Buia come la notte che striscia dietro di me,
flebile come una fiamma un attimo e vola via
Si insinua in un pensiero quando si spengono le luci,
cerchi un ricordo a buon mercato per poterle
Fuggire via, via, via, via

Amore abbracciami prima che scivoli via,
raccontami favole e menti alla notte
Per me, per me, per me, per me

Mi scopro un istante da solo e lei lì dietro di me,
con un elenco di stelle ormai lontane da me
Qualsiasi sia la meta l'ultimo porto è là,
sorrido e penso che in fondo la sorte non ha fantasia
No, no, no, no

Amore abbracciami prima che scivoli via,
raccontami favole e menti alla notte
Per me, per me, per me, per me

Lasciati in balia di onde in un mare infinito,
se ci fosse un Dio gli griderei perché?
Ma amore tu stringimi forte, nocchiero di anime perse,
che sanno che terra non c'è, ma si perdono
Dolci in te, in te, in te, in te

Amore abbracciami prima che scivoli via,
raccontami favole e menti alla notte
Per me, per me, per me, per me`,
  },
  {
    title: "Dove Sai",
    spotify: "https://open.spotify.com/track/1VtPbMKB2yULR8bDAl6MoW",
    duration: "3:34",
    preview:
      "https://p.scdn.co/mp3-preview/3e14fe82bc1f71a45c1bb1878838f168bc85e49b",
    lyrics: `Ti immaginavo diversa sai
Un po' più appariscente dai
Non sento più le mie mani

Sempre senza difese amai
E ciò che ho perso con me portai
Questa vita ci porta assai lontani

No niente carrozze d'oro mi darai
Non voglio canzoni, né fiorai
Né epitaffi che non ricorderai

Solo sedermi dove sai
Come un bambino tu mi troverai
No non finisce mai questa vita sai
Soffia il vento e via mi porterai`,
  },
  {
    title: "Vieni A Me",
    spotify: "https://open.spotify.com/track/3ID9vsyF0Ao5AfUjfTNjmB",
    duration: "4:09",
    preview:
      "https://p.scdn.co/mp3-preview/e73827ae691a45de5c475648f65ec9a7e4fc3822",
    lyrics: `Conti le lucciole che cadon giù
dietro ad un vetro appannato che dimostra sei vivo
Sale una voce c'è un ladro per strada
seguitemi adesso e impugna una spada

Tu eri sangue senza miserie, fuoco e fiamme, vieni a me
Affida a me questo tuo cuore, col suo dolore tu cerchi me
Io sono qui che ti aspetto nel buio materno che arrivi l'inverno
E quando verrai alla mia porta tu bussa sereno, tu vieni a me

No non ho forza di alzare la testa
schiacciata dal peso dei loro sguardi
Solitudine imposta da mani macchiate su croci dorate
Prima dell'ultimo assassino guarda chi a te è seduto vicino
Prima dell'ultimo assassino guarda chi a te è seduto vicino

Tu eri sangue senza miserie, fuoco e fiamme, vieni a me
Affida a me questo tuo cuore, col suo dolore tu cerchi me
Io sono qui che ti aspetto nel buio materno che arrivi l'inverno
E quando verrai alla mia porta tu bussa sereno, tu vieni a me`,
  },
  {
    title: "Underground",
    spotify: "https://open.spotify.com/track/5YmvBb8rntKtcfaBHknyze",
    duration: "2:25",
    preview:
      "https://p.scdn.co/mp3-preview/ef5d5bb0f13de88769085558e4f7f8c74b728cdb",
    lyrics: `Dove la luce fende il buio
Nel più profondo scendi
Underground

Seguimi
Stringimi
Underground

Dove gli sguardi non arrivano
Ed una fiamma danza
Underground

Prendimi
Amami
Underground`,
  },
];


export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
